import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["heroCta", "bar"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.barTarget.classList.add("hidden")
          } else {
            this.barTarget.classList.remove("hidden")
          }
        })
      },
      { threshold: 0 }
    )

    if (this.hasHeroCtaTarget) {
      this.observer.observe(this.heroCtaTarget)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
